export default __webpack_public_path__ + "static/media/corporate.66117445.png";